const defaultCountry = 'norway';

const availableCountries = ['norway', 'sweden']; // For now

const envCountry = process.env.GATSBY_COUNTRY;

export default availableCountries.includes(envCountry ?? defaultCountry)
  ? envCountry
  : defaultCountry;
